// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames not based on template
	if (chunkId === 3006) return "static/chunks/3006-2be8ee88de1d11bb.js";
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"1160":"a77c0a214e6cf3bb","1294":"09bfa104db51af47","3509":"e01e052f34366202","3786":"dbc811def14d1e79","5339":"16255414259777f9","7031":"8ff0b8ab4d3956ec"}[chunkId] + ".js";
};